exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ":host {\n  display: block; }\n\n.signature-preview {\n  min-height: 160px;\n  border: 1px solid #d9d9d9;\n  border-radius: 4px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n  background: #f8f8f8;\n  overflow: hidden; }\n\n.signature-preview img {\n  width: 100%;\n  max-height: 300px;\n  object-fit: contain; }\n\n.expiration-date-wrapper {\n  position: relative;\n  z-index: 20; }\n\n:host /deep/ app-t2-card.signature-modal .t2-card.card-modal,\n:host /deep/ app-t2-card.signature-modal .t2-card.card-modal .card-content {\n  overflow: visible; }\n\n:host /deep/ .expiration-date-wrapper .mydp .selector {\n  z-index: 1200 !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/rider/components/rider-signatures/rider-signatures.component.scss
// module id = 2094
// module chunks = 66